import React, { useState, useMemo, useEffect } from 'react';

//Components
import { Button, Badge, Modal } from 'react-bootstrap';
import ModalCreateNewClient from '../PaymentPost/ModalCreateNewClient';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import NewAddressForm from '../PaymentPost/Maps/NewAddressFrom';
import ModalViewLocation from '../PaymentPost/Maps/ModalViewLocation';
import { ClearPhone } from '../../utils/ClearPhone';
import { AuthDgiFetchAPI } from '../../api/Paymentpost/AuthDgi';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';

//libraries
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment-timezone';

//Apis
import { ClientsFetchAPI } from '../../api/Clients';
import { OrdersFetchAPI } from '../../api/Orders';
import ModalParthners from '../PaymentPost/ModalParthners';
import ModalQuoteDetails from '../PaymentPost/ModalQuoteDetails';
import Swal from 'sweetalert2';

export default function ClientPillCard({ dataClientSelected, setdataClientSelected, addressNowLocation, setAddressNowLocation, parthner_order, setShoppingCart, calculateInvoiceTotals, enabledOnlineOrder, parthners, selectRestaurant, setResetData, shoppingCart, shoppingCartCombos, setShoppingCartCombos, questionConfirmation }) {
  //********************************STATE VARIABLES*****************************************
  const [showDirectParthner, setShowDirectParthner] = useState(false);
  //STATES CLIENTS
  const [clients, setClients] = useState([]);
  //-----------------------------------------
  //STATES ORDERS
  const [ordersClient, setOrdersClient] = useState([])
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [tempSelectedClient, setTempSelectedClient] = useState(null);

  //-----------------------------------------//STATES CLIENT INFO EDIT
  const [nameEdit, setNameEdit] = useState("");
  const [PhoneEdit, setPhoneEdit] = useState("");
  const [nicknameEdit, setNicknameEdit] = useState("");
  const [EmailEdit, setEmailEdit] = useState("");
  const [rucEdit, setRucEdit] = useState("");
  const [dvEdit, setDvEdit] = useState("");
  const [OrdersQuote, setOrdersQuote] = useState([])
  const [showQuoteDetails, setShowQuoteDetails] = useState(false);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [branchOfficeData, setBranchofficeData] = useState({
    "ruc": "",
    "dv": "",
    "name": "",
    "ruc_type": "",
    "direction": "",
    "dgi_name": "",
  });

  useEffect(() => {
    dataSetClientEdit(dataClientSelected)
  }, [])

  //function to set data edit client
  const dataSetClientEdit = (client) => {
    setNameEdit(client !== null && client.name !== undefined ? client.name : '');
    setPhoneEdit(client !== null && client.phone !== undefined ? client.phone : '');
    setNicknameEdit(client !== null && client.nickname !== undefined ? client.nickname : '');
    setEmailEdit(client !== null && client.email !== undefined ? client.email : '');
    setRucEdit(client !== null && client.ruc !== undefined ? client.ruc : '');
    setDvEdit(client !== null && client.dv !== undefined ? client.dv : '');
  }
  //-----------------------------------------
  //STATES ADDRESS
  const [address, setAddress] = useState([]);
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [selectedAddress, setSelectedAddress] = useState(null);

  //-----------------------------------------
  //MODALS AND TABS FLOW
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('info');
  const [showAddAddress, setShowAddAddress] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isChangingClient, setIsChangingClient] = useState(false);
  //****************************************************************************************
  //****************************************************************************************
  //**************************************INFO GENERAL**************************************
  //CREDENTIALS AND MACHINE INFO
  const token = localStorage.getItem("x-access-machine-token");
  const [business_code, setbusiness_code] = useState(() => {
    if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
      return JSON.parse(localStorage.getItem("business")).code
    }
  });

  const [branchoffice_code, setbranchoffice_code] = useState(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      return JSON.parse(localStorage.getItem("branchoffice")).code
    }
  });

  const [machine, setmachine] = useState(() => {
    if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
      return JSON.parse(localStorage.getItem("machine"))
    }
  });

  let iconGeneral = ""
  if (localStorage.getItem('businessLogo') != null || localStorage.getItem('businessLogo') != undefined || localStorage.getItem('businessLogo') != "") {
    iconGeneral = localStorage.getItem('businessLogo')
  }
  //****************************************************************************************
  //*************************FILTER DATA CLIENTS "SEARCHS"**********************************

  //Filter clients
  const [searchTerm, setSearchTerm] = useState('');
  const [searchedClients, setSearchedClients] = useState("")
  const [orderSort, setOrderSort] = useState('asc')

  //Filter the products by the term searched 
  const filteredProducts = useMemo(() => {
    if (searchTerm === '') {
      return clients
    }
    const term = searchTerm.toLowerCase();
    return searchedClients.filter(data => {
      console.log("cliente data:", data);
      const nameMatch = data.name.toLowerCase().includes(term);
      const phoneMatch = (data.phone || '').toLowerCase().includes(term);
      const emailMatch = (data.email || '').toLowerCase().includes(term);
      return nameMatch || phoneMatch || emailMatch;

    })
  }, [searchTerm, clients]);

  //****************************************************************************************
  //************************SELECT CLIENT AND FILTER DATA CLIENTS***************************
  //get client by business 
  const getClientsByBusiness = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business_id = JSON.parse(localStorage.getItem('business')).id
        if (parthner_order == true) {
          business_id = branchoffice.parthner_business
        }
        const response = await ClientsFetchAPI.getClientsByBusiness(business_id, token);
        resolve(response.data.data);
        let clientSort = sortJSON(response.data.data, "name")
        setClients(clientSort)
        setSearchedClients(clientSort)

        console.log(clientSort);
        setOrderSort('asc')
        setIsChangingClient(true)
      } catch (err) {
        setClients([])
        setSearchedClients([])
        setOrderSort('asc')
        setIsChangingClient(true)
        AlertSmall('Error al obtener los clientes', 'error');
        console.log(err);
        reject(err);
      }
    });
  }

  //function to handle filter
  const handleFilter = () => {
    if (orderSort === 'asc') {
      setOrderSort('desc')
    } else {
      setOrderSort('asc')
    }
    if (searchTerm === '') {
      sortJSON(clients, 'name')
    } else {
      sortJSON(filteredProducts, 'name')
    }
  }

  //function to sort json
  function sortJSON(data, key) {
    return data.sort(function (a, b) {
      var x = a[key],
        y = b[key];

      if (orderSort === 'asc') {
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      }

      if (orderSort === 'desc') {
        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      }
    });
  }

  //FUNCTION TO CHANGE CLIENT
  const handleChangeClient = (client) => {
    if (client) {

      localStorage.setItem('client_data', JSON.stringify(client));
      setdataClientSelected(client);
      setIsChangingClient(false);
      setTempSelectedClient(null);
      setActiveTab('info');
      getTransactionByClient(client.id)
      getOrderQuote(client.id)
      dataSetClientEdit(client)
    }
  };

  //****************************************************************************************
  //********************************GET ORDERS BY CLIENT************************************
  const [minDate, setMinDate] = useState(moment().subtract(3, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
  const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00');

  //function to handle range change
  const [selectedRange, setSelectedRange] = useState('threeMonths');

  // Handle range change and call the corresponding function
  const handleRangeChange = (range) => {
    setSelectedRange(range);
    if (range === 'threeMonths') setRangeThreeMonths();
    if (range === 'sixMonths') setRangeSixMonths();
    if (range === 'oneYear') setRangeOneYear();
  };

  // Set range to last 3 months
  const setRangeThreeMonths = () => {
    const startDate = moment().subtract(3, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00';
    const endDate = moment().tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00';
    setMinDate(startDate);
    setMaxDate(endDate);
    getTransactionByClient(dataClientSelected.id, startDate, endDate);
    getOrderQuote(dataClientSelected.id, startDate, endDate);
  };

  // Set range to last 6 months
  const setRangeSixMonths = () => {
    const startDate = moment().subtract(6, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00';
    const endDate = moment().tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00';
    setMinDate(startDate);
    setMaxDate(endDate);
    getTransactionByClient(dataClientSelected.id, startDate, endDate);
    getOrderQuote(dataClientSelected.id, startDate, endDate)
  };

  // Set range to last 1 year
  const setRangeOneYear = () => {
    const startDate = moment().subtract(12, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00';
    const endDate = moment().tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00';
    setMinDate(startDate);
    setMaxDate(endDate);
    getTransactionByClient(dataClientSelected.id, startDate, endDate);
    getOrderQuote(dataClientSelected.id, startDate, endDate)
  };


  // Fetch order quote details
  const getOrderQuote = async (client_id, dateintial, dateend) => {
    let min = dateintial || minDate;
    let max = dateend || maxDate;
    try {
      const responsePending = await OrdersFetchAPI.getOrdersTempPendingByClienId(business_code, branchoffice_code, min, max, 0, 0, machine.id, 0, token, client_id, true)
      setOrdersQuote(responsePending.data.temp_orders)

    } catch (err) {
      setOrdersQuote([])
    }
  }

  //get orders by client
  const getTransactionByClient = async (client_id, dateintial, dateend) => {
    let min = dateintial || minDate;
    let max = dateend || maxDate;
    try {
      const response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyTable(business_code, branchoffice_code, min, max, 0, 0, 0, 0, token, client_id);
      console.log("historico de transacciones del cliente", response.data.orders);
      setOrdersClient(response.data.orders)
    } catch (error) {
      console.log(error);
    }
  }
  //*************************************************************************
  //********************************GET ADDRESS BY CLIENT******************** 

  //get address by client
  const getAddressClientNow = async () => {
    try {
      const response = await ClientsFetchAPI.getAddressClient(dataClientSelected.id, token);
      setAddress(response.data.data)


      console.log(addressNowLocation);

      if (addressNowLocation == null) {
        let defaultAddress = response.data.data.find(addr => addr.is_default === 1);

        if (defaultAddress) {
          setData(defaultAddress)
        } else {
          setData(response.data.data[0]);
        }

        function setData(data) {
          setSelectedAddress(data);
          setAddressNowLocation(data);
          localStorage.setItem("addressNowLocation", JSON.stringify(data));
        }

      }

      console.log(coordinates);

    } catch (err) {
      setAddress([])
      console.log("Error al obtener las direcciones del cliente: ", err);
    }
  }

  //get address by id
  const getAddressByIdNow = async (direction_id) => {
    try {
      const response = await ClientsFetchAPI.getAddressById(direction_id, token);
      setAddressNowLocation(response.data.direction)
      setSelectedAddress(response.data.direction);
      setActiveTab('info')
      localStorage.setItem("addressNowLocation", JSON.stringify(response.data.direction));
    } catch (err) {
      console.log("Error al obtener la direccion por id: ", err);
    }
  }

  //update address client
  const updateClientAddress = async (address_id, data) => {
    let dataSource = data
    dataSource.is_default = data.is_default === 1 ? 0 : 1
    try {
      const response = await ClientsFetchAPI.updateAddressClient(address_id, dataSource, token);
      getAddressClientNow()
    } catch (err) {
      console.log(err);
    }
  }



  //function to delete address client
  const deleteClientAddress = async (address_id) => {
    try {
      const response = await ClientsFetchAPI.deleteAddressClient(address_id, token);
      ErrorAlert("Exito", "Direccion eliminada correctamente", "success")
      getAddressClientNow()
    } catch (error) {
      ErrorAlert("", error.message, "error")
    }
  }

  //function to save address selected
  const handleSaveAddressSelection = (address) => {
    AlertSmall(`Dirección "${address.name}" seleccionada como dirección de entrega`, 'info');
    localStorage.setItem("addressNowLocation", JSON.stringify(address));
    setAddressNowLocation(address);
    setSelectedAddress(address);
    setActiveTab('info')
  };

  //****************************************************************************************
  //********************************EDIT DATA CLIENT****************************************
  const getClientType = async (dTipoRec) => {
    let token = localStorage.getItem('x-access-machine-token');
    try {
      const responseTypeClient = await ClientsFetchAPI.getClientType(token)
      console.log(responseTypeClient);
      let dataTypes = responseTypeClient.data.data;

      let dataNow = dataTypes.find(type => type.name.toLowerCase() == dTipoRec.toLowerCase())
      if (dataNow != undefined) { return dataNow.id } else { return 2 }
    } catch (err) {
      console.log(err);
      return 2;
    }
  }

  const authenticationDgi = async () => {
    if (rucEdit == "") {
      return 0
    } else {
      let token = localStorage.getItem('x-access-machine-token');
      let data = { ruc: rucEdit }
      try {
        const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
        let dataDgi = response.data
        let dTipoRec = dataDgi?.dgi_response?.dTipoRec ? dataDgi.dgi_response.dTipoRec : "Consumidor final"
        let clientType = await getClientType(dTipoRec)


        if (dataDgi.dgi_response.gResProc) {
          if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
            let dvDgi = dataDgi.dgi_response.dDV
            if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
            return { clientType: clientType, billing_name: dataDgi.dgi_response.dNomb, dv: dvDgi, typeRuc: dataDgi.dgi_response.dTipoRuc };
          } else {
            return 0
          }
        }
      } catch (err) {
        console.log(err);
        return 0

      }
    }
  }

  const getTemporalOrderById = async (order) => {
    try {
      let token = localStorage.getItem('x-access-machine-token');
      const response = await OrdersFetchAPI.getTempOrderById(order._id, token);
      let dataOrder = response.data.pre_order

      console.log("DataOrder quote", dataOrder);
      const dataclient = await getClientById(dataOrder.client_id)
      questionConfirmation(dataOrder, dataclient)
      setShowModal(false);
    } catch (err) {
      console.log(err);
    }
  }

  //get client by id 
  const getClientById = async (client_id) => {
    try {
      let machine_token = localStorage.getItem('x-access-machine-token');
      const response = await ClientsFetchAPI.getClientsById(client_id, machine_token);
      return response.data.data;

    } catch (err) {
      return null
    }
  }

  const editUser = async () => {
    LoadingAlert('Editando usuario')
    let token = localStorage.getItem('x-access-machine-token')
    let business = JSON.parse(localStorage.getItem('business'))

    let data = {};

    const authDgi1 = await authenticationDgi();

    if (nameEdit !== dataClientSelected.name) data.name = nameEdit;
    if (PhoneEdit !== dataClientSelected.phone) data.phone = PhoneEdit;
    if (EmailEdit !== dataClientSelected.email) data.email = EmailEdit;
    if (nicknameEdit !== dataClientSelected.nickname) data.nickname = nicknameEdit;
    if (rucEdit !== dataClientSelected.ruc) data.ruc = rucEdit;
    if (dvEdit !== dataClientSelected.dv) data.dv = dvEdit;

    // Estos campos siempre se envían
    if (authDgi1 !== 0) {
      data.billing_name = authDgi1.billing_name;
      data.client_type_id = authDgi1.clientType;
      data.dv = authDgi1.dv;
      data.client_ruc_type = authDgi1.typeRuc;
    }
    data.business_code = business.code;

    try {
      const response = await ClientsFetchAPI.updateClient(data, dataClientSelected.id, token)
      AlertSmall('Usuario actualizado con exito', 'success')
      const responseClients = await getClientsByBusiness()
      let clientUpdated = responseClients.find(client => client.id === dataClientSelected.id);
      setdataClientSelected(clientUpdated);
      localStorage.setItem('client_data', JSON.stringify(clientUpdated));
      setIsEditing(false)
      setIsChangingClient(false);
    } catch (err) {
      console.log(err)
      ErrorAlert('', err.response.data.error ? err.response.data.error : "Error al crear usuario", 'error')
    }

  }
  //****************************************************************************************
  //********************************MODAL FLOW**********************************************
  const handleOpenModal = () => {
    setShowModal(true);
    setActiveTab('info');
    setIsEditing(false);
    setShowAddAddress(false);
    setSelectedOrder(null);
    setIsChangingClient(false);
    setTempSelectedClient(null);

    if (!dataClientSelected) {

      getClientsByBusiness();
      setIsChangingClient(true);
    } else {
      getAddressClientNow()
      getTransactionByClient(dataClientSelected.id)
    }
  };


  const handleRemoved = () => {
    setShowModal(false);
    setActiveTab('info');
    setIsEditing(false);
    setShowAddAddress(false);
    setSelectedOrder(null);
    setIsChangingClient(false);
    setTempSelectedClient(null);
    localStorage.removeItem('client_data');
    localStorage.removeItem('addressNowLocation');
    setdataClientSelected(null);
    setAddressNowLocation(null);

  };

  //****************************************************************************************
  //****************************************************************************************
  //*******************************SEND ORDER TO THE SHOPPING CART**************************

  const handleSendToCart = (orderDirect) => {
    let Order = orderDirect || selectedOrder;
    if (Order) {
      //alert(`Pedido #${selectedOrder.id} agregado al carrito con ${selectedOrder.productos.length} productos`);
      let groupsOrderNow = JSON.parse(JSON.stringify(Order.groups));
      if (Order.groups.length > 0) {
        findProductinMenu(groupsOrderNow)
      }
    }
  };

  //function to find products in menu to set data of old order
  const findProductinMenu = (groups) => {
    let foundGroupsWithCartIndex = []
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let generalData = JSON.parse(localStorage.getItem('generalData'))
    let generalDataBranchGroups = generalData.find((dataNow) => {
      if (dataNow.branchoffice_id == branchoffice.id) {
        return dataNow
      }
    })
    let groupEnabled = generalDataBranchGroups?.data?.groups.filter(group => group.status === 1);
    groupEnabled.forEach(group => {
      let dataGroupNow = groups.find(item => group.group_id === item.group_id)
      if (dataGroupNow !== undefined) {
        dataGroupNow.segmentsOption = group.segments
        dataGroupNow.price = group.price
        foundGroupsWithCartIndex.push(addProductdataSet(dataGroupNow, group.segments, dataGroupNow.segments))
      }
    });

    setShoppingCart(foundGroupsWithCartIndex)
    calculateInvoiceTotals(foundGroupsWithCartIndex, [])
    AlertSmall(`Pedido agregado al carrito con ${foundGroupsWithCartIndex.length} productos`, 'success');
    handleCloseModal()

  }

  //Function to add format products to the shopping cart
  const addProductdataSet = (selectProduct, segmentsOption, segmentsSelect) => {
    console.log("selectProduct to add to cart", selectProduct);
    console.log("segmentsOption", segmentsOption);
    console.log("segmentsSelect", segmentsSelect);
    //------------------------------------------------------------
    //For default we set that the amount of the selected product depending the number 
    selectProduct.isNewAdd = true;
    selectProduct.amount = selectProduct.amount;
    selectProduct.cantidadItem = selectProduct.cantidadItem;
    selectProduct.delivery_type = "comer aqui";
    selectProduct.note = selectProduct.notes;
    selectProduct.unit_discount = 0;
    selectProduct.product_discount = 0;
    selectProduct.descuento = selectProduct.product_discount;
    selectProduct.discount = selectProduct.product_discount;
    selectProduct.kitchen_action = "send_to_kitchen"; // <-- NEW

    //For default we initialice the segments empty of the selected product
    let segments = [];
    let detalleSegmentos = [];
    selectProduct.segments_string = "" + selectProduct.group_id
    //We set the segment items selected on the product selected

    let temporal_segment_string = ""
    segmentsOption.forEach((segment) => {

      let items = segment.items

      let findSegment = segmentsSelect.find(segmentNow => segmentNow?.segment_id == segment?.segment_id)
      if (findSegment !== undefined) {
        items.forEach((item) => {
          if (findSegment?.item?.item_id == item?.item_id) {
            temporal_segment_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
            selectProduct.segments_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
            segments.push({ ...item, segment_name: segment.name, cantidadItem: 1, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: 1, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
            detalleSegmentos.push({ ...item, segment_name: segment.name, cantidadItem: 1, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: 1, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
            selectProduct.price = selectProduct.price + item.price
          }
        })
      }
    });

    console.log("segments", segments);
    selectProduct.segments = segments;
    selectProduct.DetalleSegmentos = detalleSegmentos;

    return (selectProduct)
  }

  //****************************************************************************************


  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setShowAddAddress(false);
    setIsChangingClient(false);
    setTempSelectedClient(null);
  };

  const actionDistanceAddress = (address) => {
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))

    const centerLat = branchoffice.lat; // Example: Panama City
    const centerLng = branchoffice.lng;
    const deliveryRadiusKm = 1; // 10 km radius

    // When user selects a location:
    const isInsideDeliveryArea = getDistanceFromLatLonInKm(
      centerLat,
      centerLng,
      address.lat,
      address.lng
    ) <= deliveryRadiusKm;

    if (!isInsideDeliveryArea) {

      if (parthners.length > 0) {
        console.log("Sucursal mas cercana: ", parthners);
        handleSaveAddressSelection(address)
      } else {
        ErrorAlert("Fuera del área de entrega", `La dirección seleccionada está fuera del área de entrega de ${deliveryRadiusKm} km.`, "warning");
      }

    } else {
      handleSaveAddressSelection(address)
    }
  }


  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }



  useEffect(() => {
    (async () => {


      try {
        let business = ''
        let token = ''
        let branchoffice = ''
        if (localStorage.getItem("branchoffice") !== "" || localStorage.getItem("branchoffice") !== null || localStorage.getItem("branchoffice") !== undefined) {

          business = JSON.parse(localStorage.getItem("business"))
          branchoffice = JSON.parse(localStorage.getItem("branchoffice"))

        }

        //We get the branchoffice info 
        const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business.code, branchoffice.code);
        //We set the business data 
        setBranchofficeData(response_branch.data.branchoffice);

      } catch (err) {
        setBranchofficeData({
          "ruc": "",
          "dv": "",
          "name": "",
          "ruc_type": "",
          "direction": "",
          "dgi_name": "",
        })
      }
    })();
  }, []);



  return (
    <div className="">
      {parthners.length > 0 && <ModalParthners parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} calculateInvoiceTotals={calculateInvoiceTotals} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCart={setShoppingCart} setShoppingCartCombos={setShoppingCartCombos} showDirectParthner={showDirectParthner} buttonEnabled={false} />
      }
      <div className="row ">
        <div key={0} className="col-12 w-100">
          <div className="card  p-1 m-0" style={{

            overflow: 'hidden'
          }}>
            {/* <div className="card-body px-1 py-1">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">

                <div className="d-flex align-items-center gap-3">
                  <div className="card-pill-client-avatar">
                    <i class="uil uil-user-circle display-6"></i>
                  </div>
                  <div>
                    <h6 className="mb-0 fw-bold">{dataClientSelected?.name !== undefined ? dataClientSelected.name : <>Selecciona un cliente</>}</h6>
                    <small className="text-muted">Cliente</small>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-4 flex-wrap">
                  <button
                    className="btn btn-sm btn-outline-primary rounded-pill px-3"
                    onClick={() => handleOpenModal()}
                  >
                    {dataClientSelected !== null ? <>Ver detalle</> : <>Buscar o crear</>}
                  </button>



                  {dataClientSelected !== null && <button
                    className="btn btn-sm btn-outline-danger rounded-pill px-3"
                    onClick={() => handleRemoved()}
                  >
                    Remover
                  </button>}

                </div>

              </div>
            </div> */}

            <div className="card-body px-2 py-2">
              <div className="sp-client-pill" onClick={() => handleOpenModal()}>

                <div className="sp-client-id">
                  <div className="card-pill-client-avatar">
                    <i className="uil uil-user-circle" />
                  </div>
                  <div className="sp-client-text">
                    <h6
                      className={`sp-client-name fw-bold ${dataClientSelected?.name === undefined ? "is-empty" : ""}`}
                      title={dataClientSelected?.name}
                    >
                      {dataClientSelected?.name !== undefined ? dataClientSelected.name : <>Selecciona un cliente</>}
                    </h6>
                    <small className="sp-client-role text-muted">Cliente</small>
                  </div>
                </div>

                <div className="sp-client-actions d-none d-md-block d-lg-block">
                  <button
                    className="btn btn-sm btn-outline-primary rounded-pill px-3"
                    onClick={() => handleOpenModal()}
                  >
                    {dataClientSelected !== null ? <>Ver detalle</> : <>Buscar o crear</>}
                  </button>

                  {dataClientSelected !== null && <button
                    className="btn btn-sm btn-outline-danger rounded-pill px-3"
                    onClick={() => handleRemoved()}
                  >
                    Remover
                  </button>}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <>
          <div
            className={`modal fade ${showModal ? 'show' : ''}`}
            style={{ display: showModal ? 'block' : 'none' }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: '99%', maxHeight: '99vh' }}>
              <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', height: '99vh' }}>
                {/* Header */}
                <div className="modal-header border-0 pb-0 d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center mb-2 gap-2">
                  <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center mb-2 gap-2 flex-grow-1">
                    <div className='d-none d-lg-block' style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '24px'
                    }}>
                      {/*getTipoIcon(selectedClient.tipo)*/}
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="mb-0 fw-bold">{dataClientSelected?.name !== undefined ? dataClientSelected.name : <>Selecciona un cliente</>}</h5>
                      <small className="text-muted">Cliente</small>
                      {/*<span className={`badge bg-${getStatusColor(selectedClient.estado)} mt-1`}>
                        {selectedClient.estado}
                      </span>*/}
                    </div>
                    {!isEditing && !isChangingClient && (
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-outline-secondary btn-sm rounded-pill"
                          onClick={() => getClientsByBusiness()}
                        >
                          Cambiar cliente
                        </button>
                        <button
                          className="btn btn-outline-primary btn-sm rounded-pill"
                          onClick={() => setIsEditing(true)}
                        >
                          Editar cliente
                        </button>

                        {dataClientSelected !== null && <button
                          className="btn btn-sm btn-outline-danger rounded-pill px-3"
                          onClick={() => handleRemoved()}
                        >
                          Remover
                        </button>}
                      </div>
                    )}
                  </div>
                  {/* <button
                    type="button"
                    className="btn-close ms-2 d-none d-lg-block"
                    onClick={handleCloseModal}
                  ></button> */}
                </div>

                {/* Body */}
                <div className="modal-body px-4" style={{ overflowY: 'auto', flex: 1 }}>

                  {isChangingClient ? (
                    /* Selección de Cliente */


                    <div>
                      <div className="d-flex justify-content-between m-2 ">
                        <form className="row g-3 align-content-center align-items-center">
                          <div className="col-auto ">
                            <span className='mb-0 text-secondary fw-bold' ><i class="uil uil-search"></i> Buscar</span>
                          </div>
                          <div className="col-auto">
                            <input
                              spellcheck="false"
                              className="form-control"
                              type="text"
                              step="any"
                              placeholder="Ingrese el nombre del cliente"
                              onChange={e => setSearchTerm(e.target.value)}

                            />

                          </div>
                          <div className="col-auto">
                            <Button variant="secondary" onClick={() => handleFilter()}> {orderSort === 'asc' ? <><i class="uil uil-sort-amount-down"></i> A-Z</> : <><i class="uil uil-sort-amount-up"></i> Z-A</>}</Button>
                          </div>
                          <div className='col-auto'><ModalCreateNewClient getClients={getClientsByBusiness}></ModalCreateNewClient></div>

                        </form>
                      </div>

                      <h6 className="fw-bold mb-3">Seleccionar cliente</h6>

                      <div style={{ maxHeight: '450px', overflowY: 'auto' }} className="pe-2 border-top  border-bottom p-lg-4  px-0">
                        <div className='row g-2 justify-content-lg-center justify-content-start'>
                          {filteredProducts.map((client) => {
                            const isSelected = tempSelectedClient?.id === client.id;

                            return (

                              <div
                                key={client.id}
                                onClick={() => {
                                  setTempSelectedClient(client);
                                  handleChangeClient(client);
                                }}
                                className={`col-12 col-md-6  col-lg-3 col-xl-3 client-card mx-2   ${isSelected ? 'selected' : ''}`}
                              >
                                {/* Radio Button Indicator */}
                                <div className="client-radio-indicator">
                                  <div className="client-radio-circle">
                                    {/* <Check className="client-radio-check" strokeWidth={3} /> */}
                                  </div>
                                </div>

                                {/* Content */}
                                <div className="client-card-content">
                                  {/* Avatar */}
                                  <div className="client-avatar">
                                    {/* <User size={24} color="white" /> */}
                                  </div>

                                  {/* Client Info */}
                                  <div className="client-info">
                                    <h6 className="client-name">{client.name}</h6>

                                    <div className="client-details">
                                      <div className="client-email">
                                        {/* <Mail className="client-email-icon" /> */}
                                        <span className="client-email-text">{client.email}</span>
                                      </div>

                                      <div className="client-phone">
                                        {/* <Phone className="client-phone-icon" /> */}
                                        <span>{client.phone}</span>
                                      </div>
                                      <div className="client-billing_name">
                                        {/* <Mail className="client-email-icon" /> */}
                                        <span className="client-email-text">{client.billing_name}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>


                            );
                          })}
                        </div>
                      </div>

                      {/* <div className="d-flex gap-2 mt-3">
                        <button
                          className="btn btn-primary rounded-pill px-4"
                          onClick={handleChangeClient}
                          disabled={!tempSelectedClient}
                        >
                          Cambiar cliente
                        </button>
                        <button
                          className="btn btn-outline-secondary rounded-pill px-4"
                          onClick={() => {
                            setIsChangingClient(false);
                            setTempSelectedClient(null);
                          }}
                        >
                          Cancelar
                        </button>
                      </div> */}
                    </div>
                  ) : isEditing ? (
                    /* Formulario de Edición */
                    <div className="bg-light p-4 rounded-3">
                      <h6 className="fw-bold mb-3">Editar información del cliente</h6>
                      <div className="row g-3">
                        <div className="col-12">
                          <label className="form-label">Nombre completo</label>
                          <input
                            type="text"
                            className="form-control"
                            value={nameEdit}
                            onChange={e => setNameEdit(e.target.value)}
                            placeholder={dataClientSelected?.name}
                            name="name"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Teléfono</label>
                          <PhoneInput
                            country={'pa'} // País inicial, puedes cambiarlo
                            value={PhoneEdit}
                            onChange={phone => (setPhoneEdit(phone))}
                            inputProps={{
                              name: 'phone',
                              required: true,
                              autoFocus: true
                            }}
                            countryCodeEditable={false}
                            masks={{ pa: '.... ....' }} // Formato de 4 dígitos, espacio, 4 dígitos
                            enableSearch
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            value={EmailEdit}
                            onChange={e => setEmailEdit(e.target.value)}
                            placeholder={dataClientSelected?.email}
                            name="email"
                          />
                        </div>


                        <div className="col-md-6">
                          <label className="form-label">Ruc</label>
                          <input
                            type="text"
                            className="form-control"
                            value={rucEdit}
                            onChange={e => setRucEdit(e.target.value)}
                            placeholder={dataClientSelected?.ruc}
                            name="email"
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Dv</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dvEdit}
                            onChange={e => setDvEdit(e.target.value)}
                            placeholder={dataClientSelected?.dv}
                            name="email"
                          />
                        </div>

                      </div>
                      <div className="d-flex gap-2 mt-3">
                        <button
                          className="btn btn-primary rounded-pill px-4"
                          onClick={() => editUser()}
                        >
                          Guardar cambios
                        </button>
                        <button
                          className="btn btn-outline-secondary rounded-pill px-4"
                          onClick={() => setIsEditing(false)}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  ) : (
                    /* Tabs */
                    <>
                      <div className="">
                        <ul className="nav nav-pills mb-4 flex-nowrap  w-100  p-2 tabs-scroll-wrapper  d-flex justify-content-lg-center" >
                          <li className="nav-item bg-light ">
                            <button
                              className={`nav-link ${activeTab === 'info' ? 'active' : ''}`}
                              onClick={() => setActiveTab('info')}
                            >
                              <i className="uil uil-info-circle"></i> Información
                            </button>

                          </li>

                          <li className="nav-item bg-light ">
                            <button
                              className={`nav-link ${activeTab === 'pedidos' ? 'active' : ''}`}
                              onClick={() => (setActiveTab('pedidos'))}
                            >
                              <i className="uil uil-clipboard-notes"></i> Pedidos
                            </button>
                          </li>

                          <li className="nav-item bg-light ">
                            <button
                              className={`nav-link ${activeTab === 'quote' ? 'active' : ''}`}
                              onClick={() => (setActiveTab('quote'))}
                            >
                              <i className="uil uil-clipboard-notes"></i> Cotizaciones
                            </button>
                          </li>

                          {enabledOnlineOrder == true && <li className="nav-item bg-light ">
                            <button
                              className={`nav-link ${activeTab === 'direcciones' ? 'active' : ''}`}
                              onClick={() => (setActiveTab('direcciones'), getAddressClientNow())}
                            >
                              <i className="uil uil-location-point"></i> Direcciones
                            </button>
                          </li>}

                        </ul>
                      </div>



                      {/* Tab: Información */}
                      {activeTab === 'info' && (
                        <div>
                          <h6 className="fw-bold mb-3">Información del cliente</h6>

                          <div className="client-info-container">
                            <div className="client-info-grid">
                              {/* Teléfono */}
                              <div className="client-info-card">
                                <div className="client-info-label">
                                  Teléfono
                                </div>
                                <span className="client-info-value">{dataClientSelected?.phone}</span>
                              </div>

                              {/* Email */}
                              <div className="client-info-card">
                                <div className="client-info-label">
                                  Email
                                </div>
                                <span className="client-info-value email">{dataClientSelected?.email}</span>
                              </div>

                              {/* RUC - Condicional */}

                              {dataClientSelected?.billing_name && (
                                <div className="client-info-card">
                                  <div className="client-info-label">
                                    Nombre fiscal
                                  </div>
                                  <span className="client-info-value">{dataClientSelected.billing_name}</span>
                                </div>
                              )}
                              {dataClientSelected?.ruc && (
                                <div className="client-info-card">
                                  <div className="client-info-label">
                                    RUC
                                  </div>
                                  <span className="client-info-value">{dataClientSelected.ruc}</span>
                                </div>
                              )}

                              {/* DV - Condicional */}
                              {dataClientSelected?.dv && (
                                <div className="client-info-card">
                                  <div className="client-info-label">

                                    DV
                                  </div>
                                  <span className="client-info-value">{dataClientSelected.dv}</span>
                                </div>
                              )}

                              {/* Puntos - Card Especial */}
                              <div className="client-info-card points-card">
                                <div className="client-info-label">

                                  Puntos
                                </div>
                                <span className="client-info-value">

                                  {dataClientSelected?.points}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className='row '>
                            <div className='col-sm-6'>
                              {enabledOnlineOrder == true && <>{addressNowLocation !== null ? <>
                                <div className=''>
                                  <div className="address-display-gradient">
                                    {/* Gradient Header */}
                                    <div className="address-gradient-header">
                                      {/* <MapPin className="address-gradient-header-icon" /> */}
                                      <h3 className="address-gradient-title">Dirección de Entrega</h3>
                                    </div>

                                    {/* Body */}
                                    <div className="address-gradient-body">
                                      <div className="address-display-content">
                                        {/* Map */}
                                        <div className="address-map-preview">
                                          {addressNowLocation !== null ? (
                                            <ModalViewLocation
                                              logo={iconGeneral}
                                              address={{ lat: addressNowLocation.lat, lng: addressNowLocation.lng }}
                                            />
                                          ) : (
                                            <ModalViewLocation
                                              logo={iconGeneral}
                                              Address={{ lat: 0, lng: 0 }}
                                            />
                                          )}
                                        </div>

                                        {/* Info */}
                                        <div className="address-info-section">
                                          <div className="address-info-list">
                                            <div className="address-info-item">
                                              <i class="uil uil-map-pin-alt address-info-icon"></i>
                                              <span translate="no">
                                                <strong>Dirección:</strong> {addressNowLocation.name}
                                              </span>
                                            </div>

                                            <div className="address-info-item">
                                              <i class="uil uil-estate address-info-icon"></i>
                                              <span translate="no">
                                                <strong>Apto/Casa:</strong> {addressNowLocation.house_num}
                                              </span>
                                            </div>

                                            <div className="address-info-item">
                                              <i class="uil uil-phone address-info-icon"></i>
                                              <span translate="no">
                                                <strong>Teléfono:</strong> {addressNowLocation.phone}
                                              </span>
                                            </div>

                                            {addressNowLocation?.is_default === 1 &&
                                              <div className="address-info-item">
                                                <i class="uil uil-star address-info-icon"></i>
                                                <div className="address-default-badge">
                                                  Direccion predeterminada
                                                </div>
                                              </div>
                                            }
                                          </div>


                                          <div className="address-reference">
                                            <div className="address-reference-label">
                                              <i class="uil uil-file-alt address-reference-icon"></i>
                                              Referencia
                                            </div>
                                            <p className="address-reference-text" translate="no">
                                              {addressNowLocation.additional_info}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      {/* Action Button */}
                                      <div className="address-action-container">
                                        <button
                                          className="address-change-button"
                                          onClick={() => {
                                            setActiveTab('direcciones');
                                            getAddressClientNow();
                                          }}
                                        >
                                          <i class="uil uil-pen address-change-icon "></i>  Cambiar dirección
                                        </button>


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </> : <>
                                {/* No address selected */}
                                <div className='col-6 col-md-6 p-2 border rounded' onClick={() => (setActiveTab('direcciones'), getAddressClientNow())} role='button'>
                                  <div className="card-directions-restaurant">
                                    <div className="d-flex justify-content-center align-items-center opacity-50 text-muted">
                                      {/*<animated-icons
                                    src="https://animatedicons.co/get-icon?name=Distance&style=minimalistic&token=18f636dc-626c-433b-bc56-b868ff427698"
                                    trigger="click"
                                    attributes='{"variationThumbColour":"#FFFFFF","variationName":"Normal","variationNumber":1,"numberOfGroups":1,"backgroundIsGroup":false,"strokeWidth":2,"defaultColours":{"group-1":"#000000","background":"#FFFFFF"}}'
                                    height="80"
                                    width="80"
                                  ></animated-icons>*/}
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center">
                                      <p class="opacity-50 text-center">No tienes direccion seleccionada <br></br> Seleccionar una aqui</p>
                                    </div>
                                  </div>
                                </div>
                              </>}</>}

                            </div>

                            {ordersClient.length > 0 && <> <div className='col-sm-6'>
                              <div className="address-display-gradient">
                                {/* Gradient Header */}
                                <div className="address-gradient-header">
                                  {/* <MapPin className="address-gradient-header-icon" /> */}
                                  <h3 className="address-gradient-title">Última transacción</h3>
                                </div>
                                <div
                                  key={ordersClient[0]._id}
                                  className="order-display-card border-0"
                                >
                                  {/* Invoice Badge */}

                                  <div className="order-status-badge-container">
                                    <span className={`order-status-badge ${ordersClient[0].devolution_order_reference ? 'credit-note' : 'invoiced'}`}>
                                      {/* <Receipt className="badge-icon" /> */}
                                      <i class="uil uil-invoice"></i>
                                      {ordersClient[0].devolution_order_reference ? 'Nota a crédito' : 'Factura'}
                                    </span>
                                  </div>

                                  {/* Content */}
                                  <div className="order-display-content">
                                    {/* Order Header */}
                                    <div className="order-display-header">
                                      <h6 className="order-display-number">
                                        <i class="uil uil-shopping-cart invoice-badge-icon "></i>
                                        Pedido #{ordersClient[0].transaction_code}
                                      </h6>
                                      <div className="order-display-date">
                                        <i class="uil uil-calendar invoice-badge-icon "></i>
                                        <small>{moment(ordersClient[0].createdAt).tz('America/Bogota').format('DD/MM/YYYY HH:mm')}</small>
                                      </div>
                                    </div>

                                    {/* Products Section */}
                                    <div className="order-products-section">
                                      <div className="order-products-header">
                                        <i class="uil uil-box invoice-badge-icon "></i>
                                        Productos
                                      </div>
                                      <div className="order-products-list">
                                        {ordersClient[0].groups.map((group, idx) => (
                                          <div key={idx} className="order-product-item">
                                            <div className="order-product-info">
                                              <span className="order-product-name">{group.name}</span>
                                              <span className="order-product-quantity">×{group.amount}</span>
                                            </div>
                                            <span className="order-product-price">
                                              ${group.price.toFixed(2)}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>

                                    {/* Total */}
                                    <div className="order-total-section">
                                      <div className="order-total-row">
                                        <span className="order-total-label">Total:</span>
                                        <span className="order-total-amount">
                                          ${ordersClient[0].total.toFixed(2)}
                                        </span>
                                      </div>

                                      <div className="d-flex justify-content-center align-items-center mt-2 pt-2 border-top">
                                        <button
                                          className="btn btn-success btn-sm rounded-pill"
                                          onClick={() => handleSendToCart(ordersClient[0])}
                                        >
                                          🛒 Enviar al carrito
                                        </button></div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div></>}
                          </div>
                        </div>
                      )}

                      {/* Tab: Pedidos */}
                      {activeTab === 'pedidos' && (
                        <div>
                          <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center mb-2 gap-2">
                            <h6 className="fw-bold mb-0">Historial de pedidos</h6>

                            <div
                              className="d-flex gap-3 align-items-center px-3 py-2 overflow-x-auto"

                            >
                              {/* 3 Months */}
                              <div className="form-check form-check-inline" style={{ minWidth: 110 }}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="range"
                                  id="rangeThreeMonths"
                                  checked={selectedRange === 'threeMonths'}
                                  onChange={() => handleRangeChange('threeMonths')}
                                  style={{
                                    accentColor: '#667eea',
                                    width: 22,
                                    height: 22,
                                    marginRight: 8,
                                  }}
                                />
                                <label
                                  className="form-check-label fw-bold"
                                  htmlFor="rangeThreeMonths"
                                  style={{
                                    fontSize: '1rem',
                                    color: selectedRange === 'threeMonths' ? '#667eea' : '#333',
                                    cursor: 'pointer',
                                  }}
                                >
                                  3 Meses
                                </label>
                              </div>
                              {/* 6 Months */}
                              <div className="form-check form-check-inline" style={{ minWidth: 110 }}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="range"
                                  id="rangeSixMonths"
                                  checked={selectedRange === 'sixMonths'}
                                  onChange={() => handleRangeChange('sixMonths')}
                                  style={{
                                    accentColor: '#667eea',
                                    width: 22,
                                    height: 22,
                                    marginRight: 8,
                                  }}
                                />
                                <label
                                  className="form-check-label fw-bold"
                                  htmlFor="rangeSixMonths"
                                  style={{
                                    fontSize: '1rem',
                                    color: selectedRange === 'sixMonths' ? '#667eea' : '#333',
                                    cursor: 'pointer',
                                  }}
                                >
                                  6 Meses
                                </label>
                              </div>
                              {/* 1 Year */}
                              <div className="form-check form-check-inline" style={{ minWidth: 110 }}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="range"
                                  id="rangeOneYear"
                                  checked={selectedRange === 'oneYear'}
                                  onChange={() => handleRangeChange('oneYear')}
                                  style={{
                                    accentColor: '#667eea',
                                    width: 22,
                                    height: 22,
                                    marginRight: 8,
                                  }}
                                />
                                <label
                                  className="form-check-label fw-bold"
                                  htmlFor="rangeOneYear"
                                  style={{
                                    fontSize: '1rem',
                                    color: selectedRange === 'oneYear' ? '#667eea' : '#333',
                                    cursor: 'pointer',
                                  }}
                                >
                                  1 Año
                                </label>
                              </div>
                            </div>

                            {selectedOrder && (
                              <button
                                className="btn btn-success btn-sm rounded-pill"
                                onClick={() => handleSendToCart()}
                              >
                                🛒 Enviar al carrito
                              </button>
                            )}
                          </div>
                          <div className='row justify-content-lg-start justify-content-center ' style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {ordersClient.map((order) => {
                              const isSelected = selectedOrder?._id === order._id;
                              const isCreditNote = order.devolution_order_reference;

                              return (
                                <div
                                  key={order._id}
                                  onClick={() => !isCreditNote && setSelectedOrder(order)}
                                  className={`col-12 col-md-4 order-card-select mx-1 ${isSelected ? 'selected' : ''}`}
                                >

                                  {!isCreditNote && (
                                    <div className="radio-indicator">
                                      <div className="radio-circle">
                                      </div>
                                    </div>
                                  )}

                                  {/* Status Badge */}
                                  <div className="order-status-badge-container">
                                    <span className={`order-status-badge ${isCreditNote ? 'credit-note' : 'invoiced'}`}>
                                      {/* <Receipt className="badge-icon" /> */}
                                      <i class="uil uil-invoice"></i>
                                      {isCreditNote ? 'Nota a crédito' : 'Factura'}
                                    </span>
                                  </div>

                                  {/* Content */}
                                  <div className="order-card-select-content">
                                    {/* Order Header */}
                                    <div className="order-header">
                                      <h3 className="order-title">
                                        Pedido #{order.transaction_code}
                                      </h3>
                                      <div className="order-date">
                                        {/* <Calendar className="date-icon" /> */}
                                        <span>{moment(order.createdAt).tz('America/Bogota').format('DD/MM/YYYY HH:mm')}</span>
                                      </div>
                                    </div>

                                    {/* Products Section */}
                                    <div className="products-section">
                                      <div className="products-header">
                                        {/* <Package className="products-icon" /> */}
                                        Productos
                                      </div>
                                      <div className="products-list">
                                        {order.groups.map((group, idx) => (
                                          <div key={idx} className="product-item">
                                            <div className="product-info">
                                              <span className="product-name">{group.name}</span>
                                              <span className="product-quantity">×{group.amount}</span>
                                            </div>
                                            <span className="product-price">
                                              ${group.price.toFixed(2)}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>

                                    {/* Total */}
                                    <div className="total-section">
                                      <div className="total-row">
                                        <span className="total-label">Total:</span>
                                        <span className="total-amount">
                                          ${order.total.toFixed(2)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {activeTab === 'quote' && (
                        <div>
                          <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center mb-2 gap-2">
                            <h6 className="fw-bold mb-0">Cotizaciones</h6>
                            <div className="d-flex gap-3 align-items-center px-3 py-2 overflow-x-auto">
                              {/* 3 Meses */}
                              <div className="form-check form-check-inline" style={{ minWidth: 110 }}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="range-quote"
                                  id="rangeThreeMonthsQuote"
                                  checked={selectedRange === 'threeMonths'}
                                  onChange={() => handleRangeChange('threeMonths')}
                                  style={{
                                    accentColor: '#667eea',
                                    width: 22,
                                    height: 22,
                                    marginRight: 8,
                                  }}
                                />
                                <label
                                  className="form-check-label fw-bold"
                                  htmlFor="rangeThreeMonthsQuote"
                                  style={{
                                    fontSize: '1rem',
                                    color: selectedRange === 'threeMonths' ? '#667eea' : '#333',
                                    cursor: 'pointer',
                                  }}
                                >
                                  3 Meses
                                </label>
                              </div>
                              {/* 6 Meses */}
                              <div className="form-check form-check-inline" style={{ minWidth: 110 }}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="range-quote"
                                  id="rangeSixMonthsQuote"
                                  checked={selectedRange === 'sixMonths'}
                                  onChange={() => handleRangeChange('sixMonths')}
                                  style={{
                                    accentColor: '#667eea',
                                    width: 22,
                                    height: 22,
                                    marginRight: 8,
                                  }}
                                />
                                <label
                                  className="form-check-label fw-bold"
                                  htmlFor="rangeSixMonthsQuote"
                                  style={{
                                    fontSize: '1rem',
                                    color: selectedRange === 'sixMonths' ? '#667eea' : '#333',
                                    cursor: 'pointer',
                                  }}
                                >
                                  6 Meses
                                </label>
                              </div>
                              {/* 1 Año */}
                              <div className="form-check form-check-inline" style={{ minWidth: 110 }}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="range-quote"
                                  id="rangeOneYearQuote"
                                  checked={selectedRange === 'oneYear'}
                                  onChange={() => handleRangeChange('oneYear')}
                                  style={{
                                    accentColor: '#667eea',
                                    width: 22,
                                    height: 22,
                                    marginRight: 8,
                                  }}
                                />
                                <label
                                  className="form-check-label fw-bold"
                                  htmlFor="rangeOneYearQuote"
                                  style={{
                                    fontSize: '1rem',
                                    color: selectedRange === 'oneYear' ? '#667eea' : '#333',
                                    cursor: 'pointer',
                                  }}
                                >
                                  1 Año
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className='row justify-content-lg-start justify-content-center ' style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {OrdersQuote.length === 0 && (
                              <div className="col-12 text-center text-muted">No hay cotizaciones.</div>
                            )}
                            {OrdersQuote.map((quote) => (
                              <div key={quote._id} className="col-12 col-md-4 order-card-select mx-1">
                                <div className="order-status-badge-container">
                                  <span className="order-status-badge quoted">
                                    <i className="uil uil-clipboard-notes"></i> Cotización
                                  </span>
                                </div>
                                <div className="order-card-select-content">
                                  <div className="order-header">
                                    <h3 className="order-title">
                                      Cotización #{quote.transaction_code}
                                    </h3>
                                    <div className="order-date">
                                      <span>{moment(quote.createdAt).tz('America/Bogota').format('DD/MM/YYYY HH:mm')}</span>
                                    </div>
                                  </div>
                                  <div className="products-section">
                                    <div className="products-header">Productos</div>
                                    <div className="products-list">
                                      {quote.groups.map((group, idx) => (
                                        <div key={idx} className="product-item">
                                          <div className="product-info">
                                            <span className="product-name">{group.name}</span>
                                            <span className="product-quantity">×{group.amount}</span>
                                          </div>
                                          <span className="product-price">
                                            ${group.price.toFixed(2)}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                  <div className="total-section">
                                    <div className="total-row">
                                      <span className="total-label">Total:</span>
                                      <span className="total-amount">${quote.total.toFixed(2)}</span>
                                    </div>
                                    <div className="total-row">
                                      <span className="total-label">Cliente:</span>
                                      <span className="total-amount">{quote.client_name}</span>
                                    </div>
                                    <div className="total-row">
                                      <span className="total-label">RUC:</span>
                                      <span className="total-amount">{quote.client_ruc}</span>
                                    </div>
                                    <div className="total-row">
                                      <span className="total-label">DV:</span>
                                      <span className="total-amount">{quote.client_dv}</span>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-end mt-2">
                                    <button
                                      className="btn btn-outline-primary btn-sm rounded-pill"
                                      onClick={() => {
                                        setSelectedQuote(quote);
                                        setShowQuoteDetails(true);
                                      }}
                                    >
                                      Ver detalle
                                    </button>

                                    <button
                                      className="btn btn-outline-success btn-sm rounded-pill"
                                      onClick={() => {
                                        getTemporalOrderById(quote);
                                      }}
                                    >
                                      Enviar al carrito
                                    </button>


                                  </div>
                                </div>
                              </div>
                            ))}
                            {/* Modal para ver detalle de cotización */}
                            <ModalQuoteDetails
                              show={showQuoteDetails}
                              onClose={() => setShowQuoteDetails(false)}
                              quote={selectedQuote}
                              branchOfficeData={branchOfficeData}
                              logo={iconGeneral}
                              onShare={() => {
                                if (selectedQuote) {
                                  const domainBusiness = (localStorage.getItem('business') && JSON.parse(localStorage.getItem('business')).domain) || '';
                                  navigator.clipboard.writeText(`https://${domainBusiness}.ecommerce.smartpay.ai/order/quote/${selectedQuote.code}`);
                                  Swal.fire('¡Enlace copiado!', 'El enlace de la cotización ha sido copiado al portapapeles.', 'success');
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Tab: Direcciones */}
                      {activeTab === 'direcciones' && (
                        <div>
                          {!showAddAddress ? (
                            <>
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6 className="fw-bold mb-0">Direcciones guardadas</h6>
                                <div className="d-flex gap-2">
                                  {/*selectedAddress && (
                                    <button
                                      className="btn btn-success btn-sm rounded-pill"
                                      onClick={handleSaveAddressSelection}
                                    >
                                      💾 Guardar selección
                                    </button>
                                  )*/}
                                  <button
                                    className="btn btn-primary btn-sm rounded-pill"
                                    onClick={() => setShowAddAddress(true)}
                                  >
                                    ➕ Agregar dirección
                                  </button>
                                </div>
                              </div>

                              <div className='row' style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                {address.map((dir) => {
                                  const isSelected = selectedAddress?.id === dir.id;
                                  const isPrincipal = dir.principal;

                                  return (
                                    <div
                                      key={dir.id}
                                      onClick={() => actionDistanceAddress(dir)}
                                      className={`col-12 col-md-4 address-card  mx-1 ${isSelected ? 'selected' : ''} ${isPrincipal ? 'principal' : ''}`}
                                    >
                                      {/* Radio Button Indicator */}
                                      <div className="address-radio-indicator">
                                        <div className="address-radio-circle">

                                        </div>
                                      </div>

                                      {/* Principal Badge */}
                                      {isSelected && (
                                        <div className="principal-badge">

                                          Principal
                                        </div>
                                      )}




                                      {/* Content */}
                                      <div className="address-card-content">
                                        {/* Address Header */}
                                        <div className="address-header">
                                          <div>
                                            <h3 className="address-name">

                                              {dir.name}
                                            </h3>
                                          </div>
                                        </div>

                                        {/* Address Details */}
                                        <div className="address-details">
                                          <div className="address-detail-item">

                                            <span className="detail-label">Coordenadas:</span>
                                            <span className="detail-value">Lat: {dir.lat}, Lng: {dir.lng}</span>
                                          </div>

                                          <div className="address-detail-item">

                                            <span className="detail-label">Teléfono:</span>
                                            <span className="detail-value">{dir.phone}</span>
                                          </div>

                                          <div className="address-detail-item">

                                            <span className="detail-label">Número:</span>
                                            <span className="detail-value">{dir.house_num}</span>
                                          </div>

                                          <div className="address-detail-item">

                                            <span className="detail-label">Referencias:</span>
                                            <span className="detail-value">{dir.additional_info}</span>
                                          </div>

                                          <div className="">
                                            {dir?.is_default === 1 ? <>
                                              <Badge bg="success p-2"><i class="uil uil-star "></i> Direccion predeterminada</Badge></> : <>
                                              < button
                                                className="btn btn-outline-primary btn-sm rounded-pill"
                                                onClick={(e) => {
                                                  e.stopPropagation(); // Evita que se seleccione la card al hacer clic en eliminar
                                                  updateClientAddress(dir.id, dir)
                                                }}
                                              >
                                                {/* <Trash2 className="btn-delete-icon" /> */}
                                                Asignar predeterminado
                                              </button></>}
                                          </div>
                                        </div>


                                        {/* Actions */}
                                        {!isSelected && (

                                          <div className="address-actions">
                                            <button
                                              className="btn-delete"
                                              onClick={(e) => {
                                                e.stopPropagation(); // Evita que se seleccione la card al hacer clic en eliminar
                                                deleteClientAddress(dir.id);
                                              }}
                                            >
                                              {/* <Trash2 className="btn-delete-icon" /> */}
                                              Eliminar
                                            </button>
                                          </div>
                                        )}

                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </>
                          ) : (
                            /* Formulario para agregar dirección */

                            <>

                              <NewAddressForm setStatuslayout={setShowAddAddress} getAddressClientNow={getAddressClientNow} client_id={dataClientSelected.id} phoneClient={dataClientSelected?.phone}></NewAddressForm>
                            </>)}
                        </div>
                      )}
                    </>
                  )}

                </div>

                {/* Footer */}
                <div className="modal-footer border-0 pt-0">
                  <button
                    type="button"
                    className="btn btn-secondary rounded-pill px-4"
                    onClick={handleCloseModal}
                  >
                    Guardar
                  </button>
                </div>

              </div>
            </div>
          </div>

          {/* Backdrop */}
          <div
            className={`modal-backdrop fade ${showModal ? 'show' : ''}`}
            onClick={handleCloseModal}
          ></div>
        </>
      )
      }



    </div>
  );
}